import { Icon } from '@/components/Icon';
import { ReactNode } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './AblenkerRadio.styles';

type AblenkerRadioProps = {
  children: ReactNode;
  onStartPress: () => void;
};

export const AblenkerRadio = ({
  children,
  onStartPress,
}: AblenkerRadioProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.inner}>
        <Text style={styles.title}>Ablenker</Text>
        {children}
      </View>
      <TouchableOpacity
        activeOpacity={0.7}
        style={styles.startButton}
        onPress={onStartPress}
      >
        <Icon name="caretRight" style={styles.startIcon} />
        <Text style={styles.startLabel}>Start</Text>
      </TouchableOpacity>
    </View>
  );
};
